import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import IconShow from "canvas-core-react/lib/IconShow";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";

import FilterComponent from "../../utils/searchBar";
import Modal from "../../utils/customModal";
import {
  loadingHtml,
  moduleAction,
} from "../../utils/functions";
import useApi from "../../hooks/useApi";
import Table from "../../shared/table";
import RelationTemporal from "./RelationTemporal";
import { EXECUTE, MOD_RELATIONS } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";

export const format = (data) => {
  let detail = "";
  if (data.totalLines === data.totalLinesOk) {
    detail = <p>La operación fue realizada con éxito.</p>;
  } else {
    detail = (
      <>
        <p>Se presentaron los siguientes errores:</p>
        <ul>
          {data.details.map(({ message }, key) => (
            <li key={`res-${key}`}>{message}</li>
          ))}
        </ul>
      </>
    );
  }
  return detail;
};

const RelationApprovals = () => {
  const { t } = useTranslation();
  const { getApiCAll, cancellCall } = useApi();

  const company = useRef(0);
  const [menu, setMenu] = useState([]);
  const [data, setData] = useState({});
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(false);
  const roles = useSelector((state) => getRoles(state));
  const [pagination, setPagination] = useState({ page: 0, sizePerPage: 10 });

  const filters = [
    {
      name: "Nombre",
      property: "company.institution.companyName",
      operator: "eq",
    },
    {
      name: "Identificación",
      property: "company.institution.businessId",
      operator: "eq",
    },
    { name: "Tipo Solicitud", property: "requestType", operator: "eq" },
  ];

  useEffect(() => {
    setMenu([]);

    const { page, sizePerPage } = pagination;
    getList({ page, sizePerPage });

    return () => {
      cancellCall();
    };
  }, []);

  useEffect(() => {
    if (menu.length <= 0 && company.current > 0) {
      setDetail(true);
    }
  }, [menu, company]);

  const getList = ({ page, sizePerPage, querystring = null }) => {
    setLoading(true);

    let queryString = querystring !== null ? querystring : query;

    return getApiCAll(
      `/providers/additions-modifications-Accouts?page=${page}&size=${sizePerPage}${queryString}`
    )
      .then((response) => {
        setData(response.data.data);
        setQuery(queryString);
        setPagination({ page, sizePerPage });
        setLoading(false);
      })
      .catch(console.error);
  };

  const handleMenu = (id, open) => {
    const tmpMenu = [...menu];
    if (open === false) {
      setMenu([]);
    } else {
      tmpMenu[`menu-${id}`] = open;
      setMenu(tmpMenu);
    }
  };

  const getHeaders = () => {
    let headers = [];

    if (moduleAction(roles, MOD_RELATIONS, EXECUTE)) {
      headers.push({
        grow: 0,
        selector: "checkbox",
        center: true,
        bodyStyle: { flexGrow: 0 },
      });
    }

    headers.push(
      { selector: "company", name: t("providers.table.headers.company") },
      {
        selector: "businessId",
        name: t("providers.table.headers.identification"),
      },
      { selector: "type", name: "Tipo de solicitud" },
      {
        selector: "applicationDate",
        name: t("providers.table.headers.requestDate"),
      },
      // { selector: "account", name: t('providers.table.headers.account') },
      { selector: "state", name: t("providers.table.headers.invitationState") },
      {
        selector: "actions",
        name: t("providers.table.headers.action"),
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menu[`menu-${row.item.id}`] || false}
            setIsMenuOpen={(open) => handleMenu(row.item.id, open)}
          >
            <ActionMenuListItem
              icon={() => (
                <IconShow
                  id={`related-${row.item.id}`}
                  className="TextButton__icon--left"
                />
              )}
              onClick={() => getDetail(row)}
              link={{
                href: `/providerSite/relations/provider/detail/${row.item.id}`,
              }}
            >
              {t("general.labels.fileModal.detail")}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      }
    );

    return headers;
  };


  const getData = () => {
    let result = [];
    if (data.content && data.content.length > 0) {
      data.content.map((item) =>
        result.push({
          companyId: item.companyId,
          company: item.companyName,
          businessId: item.businessId,
          type: t(`general.relationTypes.${item.requestType}`),
          applicationDate: item.applicationDate,
          state:
            item.invitationStatus !== null &&
            item.invitationStatus !== undefined
              ? t(`general.inviteStates.${item.invitationStatus}`)
              : "",
          item,
        })
      );
    }

    return result;
  };

  const getDetail = (row) => {
    company.current = row.item.id;
    handleMenu(row.item.id, false);
  };

  const search = (type, value) => {
    let querystring = "";
    let selectedFilter = filters.filter((item) => item.property === type);
    if (selectedFilter.length > 0) {
      if (value.includes("Modificaci") || value.includes("modificaci")) {
        if (value.length == 12) {
          value = "MODIFY_ACCOUNT";
        }
      }

      if (value.includes("Adici") || value.includes("adici")) {
        if (value.length == 7) {
          value = "ADD_ACCOUNT";
        }
      }

      querystring = `&search=${type}/${selectedFilter[0].operator}/${value}`;
    }

    getList({ page: 0, sizePerPage: 10, querystring });
  };

  return (
    <>
      {data.content &&
        (!detail ? (
          <>
            <div className="flex-element left-flex">
              <FilterComponent filter={filters} searchFnc={search} />
            </div>
            <Table
              headers={getHeaders()}
              data={getData()}
              totalSize={data.totalElements}
              sizePerPage={pagination.sizePerPage}
              page={pagination.page}
              onTableChange={getList}
            />
          </>
        ) : (
          <RelationTemporal />
        ))}
      <Modal show={loading}>{loadingHtml()}</Modal>
    </>
  );
};

export default RelationApprovals;
